import React from 'react'
import cn from 'classnames'
import UserCardSmartTooltip from '../../UserCardSmartTooltip/UserCardSmartTooltip'
import FileList from '../../FileList/FileList'
import styles from '../../userCard.module.scss'
import { ReactComponent as CalcOfFiles } from '../../../../assets/icons/calcOfFiles.svg'
import { ReactComponent as CloseSvg } from '../../../../assets/icons/closeIcon.svg'
import { uniqueId } from 'lodash'

const LicenseItem = ({ title, licenseFiles, endorsementFiles, items }) => {
  const [showFileList, setShowFileList] = React.useState(false)

  return (
    <div className={styles.contentItem} onMouseLeave={() => setShowFileList(false)}>
      <div className={cn(styles.header, { [styles.license]: true })}>
        <UserCardSmartTooltip
          type={'simple'}
          title={title}
          titleClass={styles.contentItemTitle}
          id={uniqueId('license-item-')}
        />

        <div className={styles.endorsementTitleContainer}>
          <h3 className={styles.endorsementTitle}>Endorsement</h3>
          {!showFileList && (
            <div
              className={styles.calcOfFilesContainer}
              onClick={() => {
                ;(endorsementFiles.length || licenseFiles.length) && setShowFileList(true)
              }}
            >
              <label className={styles.calcOfFilesContainerLabel}>Photo</label>
              <div className={styles.calcOfFiles}>
                <CalcOfFiles />
                <label className={styles.calcOfFilesLabel}>{endorsementFiles.length + licenseFiles.length}</label>
              </div>
            </div>
          )}

          {showFileList && (
            <button
              className={styles.closeBtn}
              onClick={() => {
                ;(endorsementFiles.length || licenseFiles.length) && setShowFileList(false)
              }}
            >
              Close
              <CloseSvg />
            </button>
          )}
        </div>
      </div>

      <div className={cn(styles.body, { [styles.license]: true })}>
        {items?.map((item, index) => (
          <UserCardSmartTooltip
            key={index}
            title={item.title}
            value={item.value}
            id={uniqueId('license-item-')}
            containerClass={styles.item}
            titleClass={styles.itemTitle}
            valueClass={styles.itemValue}
          />
        ))}

        {endorsementFiles.length || endorsementFiles ? (
          <>
            <FileList files={licenseFiles} showFiles={showFileList} type={'license'} />
            <FileList files={endorsementFiles} showFiles={showFileList} type={'endorsement'} />
          </>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export default LicenseItem
